// English
export const en = {
  translation: {
    "Save": "Save",
    "Select Dispatch Group": "Select Dispatch Group",
    "This entry has no location (latitude/longitude). Please select a dispatch group to continue.":
      "This entry has no location (latitude/longitude). Please select a dispatch group to continue.",
    "Suggested dispatch groups based on entry type/subtype:":
      "Suggested dispatch groups based on entry type/subtype:",
    "No dispatch groups found for this entry type/subtype":
      "No dispatch groups found for this entry type/subtype",
    "Error loading suggested dispatch groups":
      "Error loading suggested dispatch groups",
    "Dispatch group added successfully": "Dispatch group added successfully",
    "Error adding dispatch group": "Error adding dispatch group",
    "Entry saved and dispatch group added successfully":
      "Entry saved and dispatch group added successfully",
    "Entry saved and dispatch group added":
      "Entry saved and dispatch group added",
    "Cancel": "Cancel"
  }
}